module.exports = __webpack_public_path__ + "img/602.cd004989.jpg";